import Swiper from 'swiper';
import {remove_last_seen_product_cookie, remove_last_seen_promotion_cookie} from '../components/pharmacy-search-component';
// import {enableBodyScroll} from 'body-scroll-lock';
import {convert_date_for_ios} from '../components/ios';
import {thirdparty} from '../components/thirdparty';


export default {
  currentRequest: false,
  searchArea: false,

  scrollToPharmacy(elem, parent, speed) {
    if (typeof speed == 'undefined') {
      speed = 500;
    }

    let scrollOffset = parent.scrollTop() + elem.offset().top - parent.offset().top - $('.pharmacy-search-form').outerHeight();
    parent.animate({scrollTop: scrollOffset}, speed);
  },

  initForm() {
    let self = this;
    self.coords = {
      oldLat: '',
      oldLong: '',
    };

    $('#pharmacy-search-form').find('#pharmacy-search-query').keyup(function () {
      $(this).removeAttr('data-location').removeData('location');
    });

    $('#pharmacy-search-form').on('submit', function (e) {
      e.preventDefault();

      self.clearResults();
      self.showLoader();

      let settings = self.getSettings();

      let formSettings = {}

      let $searchQuery = $(this).find('#pharmacy-search-query');

      if (typeof $searchQuery.data('location') !== 'undefined') {
        formSettings.query = $searchQuery.data('location');
      } else {
        formSettings.query = $searchQuery.val();
      }

      if (formSettings.query != '') {
        $('.hide-on-search').slideUp(300, function () {
          $(this).remove();
        });
      }

      $searchQuery.removeAttr('data-location').removeData('location');

      $.extend(settings, formSettings);
      if (self.setSettings(settings)) {
        self.setUrl();
        self.loadResults(1);
      }

      return false;
    });

    $('.get-search-location').off('click').on('click', function (e) {
      e.preventDefault();

      var $this = $(this);

      $this.find('.location').addClass('d-none');
      $this.find('.loader').removeClass('d-none');

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          $('#pharmacy-search-form').find('#pharmacy-search-query').val('Aktueller Standort').data('location', position.coords.latitude + ',' + position.coords.longitude);
          $('#pharmacy-search-form').submit();

          $this.find('.location').removeClass('d-none');
          $this.find('.loader').addClass('d-none');
        }, function () {
          $this.find('.location').removeClass('d-none');
          $this.find('.loader').addClass('d-none');
        }, {
          enableHighAccuracy: false,
          timeout: 5000,
        });
      } else {
        $this.find('.location').removeClass('d-none');
        $this.find('.loader').addClass('d-none');
      }
    });

    if (window.location.hash && window.location.hash == '#locate') {
      $('.get-search-location').trigger('click');
      history.replaceState({}, document.title, '.');
    }
  },

  initFilter() {
    let self = this;
    const modalContent = $('.modal-content');

    modalContent.find('.pharmacy-search-btn').on('click', function (e) {
      e.preventDefault();
      self.clearResults();
      self.showLoader();

      let settings = self.getSettings();
      var active_checkbox_counter = 0;

      modalContent.find('input[type="checkbox"]').each(function(){

        var filterKey = $(this).data('filter');

        if ($(this).hasClass('active')) {
          settings.filter[filterKey] = true;
          active_checkbox_counter++;
        } else {
          settings.filter[filterKey] = false;
        }
      })

      if($('.filter-show-more').find('.active_filters').length == 0) {
        $('.filter-show-more').append('<span class="active_filters">' + '(' + active_checkbox_counter + ')' + '</span>');
      } else {
        $('.filter-show-more').find('.active_filters').remove();
        $('.filter-show-more').append('<span class="active_filters">' + '(' + active_checkbox_counter + ')' + '</span>');
      }

      if (self.setSettings(settings)) {
        self.setUrl();
        self.loadResults(1);
      }

      $('.modal-content').find('.close').click();
    });

    modalContent.find('input[type="checkbox"]').on('click', function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
      } else {
        $(this).addClass('active');
      }
    });

    modalContent.find('.set-filter-back').on('click', function (e) {
      e.preventDefault();
      self.clearResults();
      self.showLoader();

      let settings = self.getSettings();

      if($('.filter-show-more').find('.active_filters').length > 0) {
        $('.filter-show-more').find('.active_filters').remove();
      }

      modalContent.find('input[type="checkbox"]').each(function(){

        var filterKey = $(this).data('filter');

        if ($(this).hasClass('active')) {
          settings.filter[filterKey] = false;
          $(this).click();
        }
      })

      if (self.setSettings(settings)) {
        self.setUrl();
        self.loadResults(1);
      }

      $('.modal-content').find('.close').click();
    });
  },

  initSuggestions() {
    $('.pharmacy-search-suggestion').click(function (e) {
      e.preventDefault();
      $('#pharmacy-search-query').val($(this).data('suggestion'));
      $('#pharmacy-search-form').submit();
    });

    $('.btn-toggle-location').click(function (e) {
      e.preventDefault();
      $('#pharmacy-search-filter-location').click();
      $(this).fadeOut(300);
      $(this).parent('.alert').find('hr').fadeOut(300);
    })
  },

  initMap() {
    let self = this;

    // Google Map
    let script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?language=de&region=DE&key=' + mea.gmaps_api_key + '&callback=initMap';
    script.defer = true;
    script.async = true;

    window.initMap = function () {
      self.mapOffsetBottom = 0;
      if (self.isMobile) {
        self.mapOffsetBottom = 250;
      }

      if (thirdparty()) {
        if ($('#pharmacy-search-map').data('lat') !== 'undefined' > 0 && $('#pharmacy-search-map').data('lng') !== 'undefined') {
          self.icon = $('#pharmacy-search-map').data('marker');
          self.iconLocation = $('#pharmacy-search-map').data('location');
          self.iconSelected = $('#pharmacy-search-map').data('marker-selected');

          self.coordinates = {
            lat: parseFloat($('#pharmacy-search-map').data('lat')),
            lng: parseFloat($('#pharmacy-search-map').data('lng')),
          };

          let $results = $('.pharmacy-search-results').find('.pharmacy-search-result');
          if ($results.length > 0) {
            self.map = new window.google.maps.Map(document.getElementById('pharmacy-search-map'), {
              zoom: 12,
              center: self.coordinates,
              disableDefaultUI: false,
            });

            self.latlngbounds = new window.google.maps.LatLngBounds();
            self.markers = [];

            let marker = new window.google.maps.Marker({
              position: self.coordinates,
              map: self.map,
              icon: self.iconLocation,
              title: 'Location',
            });

            self.markers.push(marker)

            $results.each(function () {
              let markerPosition = new window.google.maps.LatLng(parseFloat($(this).data('lat')), parseFloat($(this).data('lng')));

              let marker = new window.google.maps.Marker({
                position: markerPosition,
                map: self.map,
                icon: self.icon,
                pharmacyID: $(this).data('id'),
                title: $(this).find('.pharmacy-title').html(),
              });

              self.latlngbounds.extend(markerPosition);

              marker.addListener('click', function () {
                $.each(self.markers, function () {
                  if (this.pharmacyID > 0) {
                    this.setIcon(self.icon);
                    $('.pharmacy-search-results').find('.pharmacy-search-result[data-id="' + this.pharmacyID + '"]').removeClass('active');
                  }
                });

                marker.setIcon(self.iconSelected);
                let $active = $('.pharmacy-search-results').find('.pharmacy-search-result[data-id="' + marker.pharmacyID + '"]');
                $active.addClass('active');
                self.scrollToPharmacy($active, $('.pharmacy-search-sidebar'));

                if ($('.pharmacy-search-results-pages').hasClass('swiper-wrapper')) {
                  let activeSlide = $('.pharmacy-search-results-pages .active').index();
                  self.slider.slideTo(activeSlide);
                }
              });

              self.markers.push(marker);
            });
          } else {
            self.map = new window.google.maps.Map(document.getElementById('pharmacy-search-map'), {
              zoom: 6,
              center: self.coordinates,
            });
          }

          window.google.maps.event.addDomListener(window, 'resize', function () {
            self.gmapsResize();
          });

          self.gmapsResize();

          self.map.addListener('dragend', function () {
            $('#pharmacy-search-in-this-area').show();
          });
        }
      }
    }

    $(window).resize(function () {
      if ($(window).width() < 992) {
        self.isMobile = true;
      } else {
        self.isMobile = false;
        self.closeMap();
      }
    }).trigger('resize');

    if (thirdparty()) {
      document.head.appendChild(script);
    }
  },

  clearResults() {
    let self = this;

    $('.pharmacy-search-results').find('.pharmacy-search-results-pages').html('');
    self.showLoader();

    $('html, body').animate({scrollTop: 0}, 500);

    $.each(self.markers, function (index) {
      self.markers[index].setMap(null);
    });
  },

  showLoader() {
    let $loadMoreContainer = $('.pharmacy-search-result-load-more');
    $loadMoreContainer.find('.btn').addClass('d-none');
    $loadMoreContainer.find('span').removeClass('d-none').addClass('d-block');
    $loadMoreContainer.removeClass('d-none');

    if ($('.pharmacy-search-map').hasClass('fixed')) {
      $('#mobile-overlay-loader').fadeIn(500);
    }
  },

  hideLoader(currentPage, data) {
    let $loadMoreContainer = $('.pharmacy-search-result-load-more');
    $loadMoreContainer.find('.btn').removeClass('d-none');
    $loadMoreContainer.find('span').removeClass('d-block').addClass('d-none');

    if ($('.pharmacy-search-map').hasClass('fixed')) {
      $('#mobile-overlay-loader').fadeOut(500);
    } else {
      $('#mobile-overlay-loader').hide();
    }

    if (currentPage == 1) {
      $loadMoreContainer.removeClass('d-none');
    } else {
      $loadMoreContainer.addClass('d-none');
    }

    if (typeof data == 'undefined' || data == false || data.length == 0 || data.length < 15) {
      $loadMoreContainer.addClass('d-none');
    }

    $(window).trigger('resize');
  },

  loadMore() {
    let self = this;

    $('.pharmacy-search-result-load-more > a').on('click', function (e) {
      e.preventDefault();
      self.showLoader();
      self.loadResults(2);
    });
  },

  loadResults(currentPage) {
    let self = this;
    let settings = self.getSettings();

    self.currentRequest = jQuery.ajax({
      type: 'POST',
      url: mea.ajax_url,
      cache: false,
      data: {
        action: 'get_pharmacies',
        currentPage: currentPage,
        settings: settings,
      },
      dataType: 'json',
      beforeSend: function () {
        if (self.currentRequest !== false) {
          self.currentRequest.abort();
        }
      },
      success: function (response) {
        self.currentRequest = false;
        self.setSettings(response.settings);
        self.setTitle();
        self.renderResults(currentPage, response.data);
        self.hideLoader(currentPage, response.data);
      },
      error: function (XMLHttpRequest, textStatus, errorThrown) {
        if (errorThrown != 'abort') {
          console.log(errorThrown);
        }
      },
    });
  },

  setUrl() {
    let self = this;

    let to = setTimeout(function () {
      let settings = self.getSettings();

      let url = mea.pharmacy_search;
      url += encodeURIComponent(settings.query) + '/';

      $.each(settings.filter, function (key, value) {
        if (String(value) == 'true') {
          let $element = $('.pharmacy-search-filter').find('[data-filter="' + key + '"]');
          url += encodeURI($element.data('url')) + '/';
        }
      });

      window.history.pushState({}, null, url);

      clearTimeout(to);
    }, 100);
  },

  setTitle() {
    let settings = this.getSettings();
    $('title').html('Gute Apotheken in ' + settings.title_locality + ' und Umgebung');
    $('meta[name="description"]').attr('content', 'Apotheken ' + settings.title_locality + '  ➤ Finden Sie Apotheken in Ihrer Nähe ✓ Notdienste ✓ Beratung vor Ort ✓ Chat ✓ Online-Shop ✓ Rezept einlösen');
  },

  setSettings(settings) {
    $('.pharmacy-search-results').data('settings', btoa(JSON.stringify(settings)));

    return this.checkSettings(settings);
  },

  checkSettings(settings) {
    if (settings.query == '') {
      $('.pharmacy-search-results > .pharmacy-search-results-pages').html('<div class="alert px-0">Bitte Straße, PLZ oder Ort als Suchbegriff eingeben.</div>');

      this.hideLoader(0, false);
      return false;
    }

    return true;
  },

  getSettings() {
    return JSON.parse(atob($('.pharmacy-search-results').data('settings')));
  },

  initAreaSearch() {
    let self = this;

    $('#pharmacy-search-in-this-area').on('click', function (e) {
      e.preventDefault();
      self.searchArea = true;

      $('#pharmacy-search-in-this-area').hide();
      $('#pharmacy-search-query').val('Gewählter Standort').data('location', self.map.getCenter().lat() + ',' + self.map.getCenter().lng());
      $('#pharmacy-search-form').submit();
    });
  },

  renderResults(currentPage, data) {
    let self = this;
    let $container = $('.pharmacy-search-results > .pharmacy-search-results-pages');
    let template = $('.pharmacy-search-result-clone').html();
    let settings = self.getSettings();

    if (Object.keys(data).length > 0) {
      if (thirdparty()) {
        if (currentPage == 1) {
          self.latlngbounds = new window.google.maps.LatLngBounds();
        }

        if (currentPage == 1) {
          self.markers = [];
        }

        let marker = new window.google.maps.Marker({
          position: {
            lat: parseFloat(settings.location.lat),
            lng: parseFloat(settings.location.lng),
          },
          map: self.map,
          icon: self.iconLocation,
          pharmacyID: 0,
          title: 'Location',
        });

        self.markers.push(marker);
      }

      $.each(data, function () {
        let res = this;
        let result = template;

        result = result.replace(/{geo_lat}/g, res.geo_lat);
        result = result.replace(/{geo_long}/g, res.geo_long);
        result = result.replace(/{customer_number}/g, res.customer_number);
        result = result.replace(/{url}/g, res.url);
        result = result.replace(/{pharmacy_name}/g, res.pharmacy_name);
        result = result.replace(/{street}/g, res.street);
        result = result.replace(/{number}/g, res.number);
        result = result.replace(/{postcode}/g, res.postcode);
        result = result.replace(/{city}/g, res.city);
        result = result.replace(/{distance}/g, res.distance);
        result = result.replace(/{phone}/g, res.phone);
        result = result.replace(/{chat}/g, res.chat);
        result = result.replace(/{onlineshop}/g, res.onlineshop);
        result = result.replace(/{begin_1}/g, res.begin_1);
        result = result.replace(/{end_1}/g, res.end_1);
        result = result.replace(/{begin_2}/g, res.begin_2);
        result = result.replace(/{end_2}/g, res.end_2);
        result = result.replace(/{emergency_service_begin}/g, (res.emergency_service_begin == null) ? '' : res.emergency_service_begin);
        result = result.replace(/{emergency_service_end}/g, (res.emergency_service_end == null) ? '' : res.emergency_service_end);

        if(res.product_retail_price) {
          result = result.replace(/{product_retail_price}/g, res.product_retail_price);
        }
        if(res.product_retail_price_type) {
          result = result.replace(/{product_retail_price_type}/g, res.product_retail_price_type);
        }
        if(res.product_calculated_price) {
          result = result.replace(/{product_calculated_price}/g, res.product_calculated_price);
        }
        if(res.product_calculated_unit) {
          result = result.replace(/{product_calculated_unit}/g, res.product_calculated_unit);
        }

        result = $(result);

        if (res.chat == '') {
          $(result).find('.btn-chat').remove();
        }

        if (res.onlineshop == '') {
          $(result).find('.btn-shop').remove();
        }

        if (settings.monthly_product == true && res.product_price != null && res.product_shop_link != '') {
          $(result).find('.pharmacy-search-shop-link').removeClass('d-none');

          let avpText  = '';
          if(res.product_retail_price_type && res.product_retail_price) {
            avpText = '<span class="product-retail-price">' + res.product_retail_price_type + '<sup>1</sup>: <s>' + res.product_retail_price + '€</s></span>';
          }

          let regulationText  = '';
          if(res.product_calculated_price && res.product_calculated_unit) {
            regulationText = '<span class="product-regulation-data">' + res.product_calculated_price + '€ / ' + res.product_calculated_unit + '</span>';
          }

          $(result).find('.pharmacy-search-shop-link > a').html(avpText + 'Für '+res.product_price+'€ im Shop kaufen<sup>*</sup>' + regulationText).attr('href', res.product_shop_link);
        } else if ((''+settings.monthly_product) === 'true' && res.product_price != null && res.product_shop_link == '') {
          $(result).find('.pharmacy-search-shop-link').removeClass('d-none');

          let avpText  = '';
          if(res.product_retail_price_type && res.product_retail_price) {
            avpText = '<span class="product-retail-price">' + res.product_retail_price_type + '<sup>1</sup>: <s>' + res.product_retail_price + '€</s></span>';
          }

          let regulationText  = '';
          if(res.product_calculated_price && res.product_calculated_unit) {
              regulationText = '<span class="product-regulation-data">' + res.product_calculated_price + '€ / ' + res.product_calculated_unit + '</span>';
          }

          $(result).find('.pharmacy-search-shop-link > a').html(avpText + 'Für '+res.product_price+'€ vor Ort kaufen<sup>*</sup>' + regulationText).attr('href', res.url);
        }  else if (((''+settings.monthly_coupon_product) === 'true' || (''+settings.filter['monthly-coupons']) === 'true') && res.coupon_url != '') {
          $(result).find('.pharmacy-search-shop-link').removeClass('d-none');
          $(result).find('.pharmacy-search-shop-link > a').html('Coupon anzeigen').attr('href', res.coupon_url);
        } else if (res.product_shop_link != '') {
          $(result).find('.pharmacy-search-shop-link').removeClass('d-none');
          $(result).find('.pharmacy-search-shop-link > a').attr('href', res.product_shop_link);
        } else {
          $(result).find('.pharmacy-search-shop-link').remove();
        }


        if (typeof res.distance == 'undefined') {
          $(result).find('.pharmacy-distance').remove();
        }

        $container.append(result);

        if (thirdparty()) {
          let markerPosition = new window.google.maps.LatLng(parseFloat(res.geo_lat), parseFloat(res.geo_long));
        console.log('res', res);
          let marker = new window.google.maps.Marker({
            position: markerPosition,
            map: self.map,
            icon: self.icon,
            pharmacyID: res.customer_number,
            title: res.pharmacy_name,
          });

          self.latlngbounds.extend(markerPosition);

          marker.addListener('click', function () {
            $.each(self.markers, function () {
              if (this.pharmacyID > 0) {
                this.setIcon(self.icon);
                $('.pharmacy-search-results').find('.pharmacy-search-result[data-id="' + this.pharmacyID + '"]').removeClass('active');
              }
            });

            marker.setIcon(self.iconSelected);
            let $active = $('.pharmacy-search-results').find('.pharmacy-search-result[data-id="' + marker.pharmacyID + '"]');
            $active.addClass('active');
            self.scrollToPharmacy($active, $('.pharmacy-search-sidebar'));

            if ($('.pharmacy-search-results-pages').hasClass('swiper-wrapper')) {
              let activeSlide = $('.pharmacy-search-results-pages .active').index();
              self.slider.slideTo(activeSlide);
            }
          });

          self.markers.push(marker);
        }
      });


      if (thirdparty()) {
        if (self.searchArea == true) {
          self.searchArea = false;

          let hits = false;

          $.each(self.markers, function () {
            let marker = this;
            if (typeof this.pharmacyID != 'undefined' && this.pharmacyID > 0) {
              if (self.map.getBounds().contains(marker.getPosition())) {
                hits = true;
                return false;
              }
            }
          });

          if (!hits) {
            self.gmapsResize();
          }
        } else {
          self.gmapsResize();
        }

        $('#mobile-open-map').removeClass('d-none');
      }

      self.renderOpeningHours($container.find('.pharmacy-search-result'));
      self.renderDistanceLink($container.find('.pharmacy-search-result'));
    } else {
      $container.html('<div class="alert alert-mea mx-auto">Es wurden keine Apotheken gefunden.</div>');
      $('#mobile-open-map').addClass('d-none');
    }

    if ($('.pharmacy-search-results-pages').hasClass('swiper-wrapper')) {
      $('.pharmacy-search-results').find('.pharmacy-search-results-pages').find('.pharmacy-search-result').addClass('swiper-slide');
      self.slider.update();
      self.slider.slideTo(0);
      // $('.pharmacy-search-results-pages').slick('refresh');
    }
  },

  renderOpeningHours($results) {
    let currentDate = new Date();
    let currentTime = ('0' + (currentDate.getHours())).slice(-2) + ':' + ('0' + (currentDate.getMinutes())).slice(-2);

    let currentDateTomorrow = new Date();
    let currentDateAfterTomorrow = new Date();

    currentDateTomorrow.setDate(currentDateTomorrow.getDate() + 1);
    currentDateAfterTomorrow.setDate(currentDateAfterTomorrow.getDate() + 2);

    if (Object.keys($results).length > 0) {
      $.each($results, function () {
        let begin_1 = $(this).data('begin-1');
        let end_1 = $(this).data('end-1');
        let begin_2 = $(this).data('begin-2');
        let end_2 = $(this).data('end-2');
        let emergency_service_begin = $(this).data('emergency-service-begin');
        let emergency_service_end = $(this).data('emergency-service-end');

        let emergencyEndDateText = '';
        if (emergency_service_begin != '' && emergency_service_end != '') {
          let emergencyEndDate = convert_date_for_ios(emergency_service_end);
          let emergencyEndMonth = ('0' + (emergencyEndDate.getMonth() + 1)).slice(-2);
          let emergencyEndDay = ('0' + (emergencyEndDate.getDate())).slice(-2);
          let emergencyText = emergencyEndDay + '.' + emergencyEndMonth;

          if (emergencyEndDate.getFullYear() == currentDate.getFullYear() && emergencyEndDate.getMonth() == currentDate.getMonth() && emergencyEndDate.getDate() == currentDate.getDate()) {
            emergencyText = 'heute';
          } else if (emergencyEndDate.getFullYear() == currentDateTomorrow.getFullYear() && emergencyEndDate.getMonth() == currentDateTomorrow.getMonth() && emergencyEndDate.getDate() == currentDateTomorrow.getDate()) {
            emergencyText = 'morgen';
          } else if (emergencyEndDate.getFullYear() == currentDateAfterTomorrow.getFullYear() && emergencyEndDate.getMonth() == currentDateAfterTomorrow.getMonth() && emergencyEndDate.getDate() == currentDateAfterTomorrow.getDate()) {
            emergencyText = 'übermorgen';
          }

          emergencyEndDateText = (emergencyText + ' ' + ('0' + (emergencyEndDate.getHours())).slice(-2) + ':' + ('0' + (emergencyEndDate.getMinutes())).slice(-2));
        }

        if (emergency_service_begin != '' && emergency_service_end != '') {
          $(this).find('.pharmacy-opening-hours').html('Geöffnet bis ' + emergencyEndDateText + ' Uhr (Notdienst)');
        } else {
          if ((begin_1 != '' && end_1 != '' && currentTime >= begin_1 && currentTime <= end_1)) {
            $(this).find('.pharmacy-opening-hours').html('Geöffnet bis ' + end_1 + ' Uhr');
          } else if ((begin_2 != '' && end_2 != '' && currentTime >= begin_2 && currentTime <= end_2)) {
            $(this).find('.pharmacy-opening-hours').html('Geöffnet bis ' + end_2 + ' Uhr');
          } else {
            $(this).find('.pharmacy-opening-hours').addClass('text-red').html('Aktuell geschlossen');
          }
        }
      });
    }
  },

  renderDistanceLink($results) {
    let self = this;

    $results.find('.pharmacy-distance').click(function () {
      let pharmacyID = $(this).parents('.pharmacy-search-result').data('id');

      if ($(window).width() < 992) {
        if (!$('.pharmacy-search-map').hasClass('fixed')) {
          $('#mobile-open-map').click();
        }
      }

      $.each(self.markers, function () {
        if (this.pharmacyID == pharmacyID) {
          let marker = this;
          new window.google.maps.event.trigger(marker, 'click');
          self.gmapsResize();
        }
      });
    });
  },

  gmapsResize() {
    let self = this;
    if (thirdparty()) {
      if (typeof self.map != 'undefined') {
        if (typeof self.latlngbounds != 'undefined') {
          let to1 = setTimeout(function () {
            clearTimeout(to1);
            self.map.setCenter(self.latlngbounds.getCenter());
            self.map.fitBounds(self.latlngbounds, {bottom: self.mapOffsetBottom});
          }, 500);
        } else if (typeof self.coordinates != 'undefined') {
          self.map.setCenter(self.coordinates);
        }

        if (self.isMobile) {
          self.map.setOptions({disableDefaultUI: true});
        } else {
          self.map.setOptions({disableDefaultUI: false});
        }
      }
    }
  },

  closeMap() {
    let self = this;
    $('.pharmacy-search-results-pages, .mobile-open-filter, .mobile-geocode-location').show();

    $('.pharmacy-search-results').removeClass('fixed');
    $('.pharmacy-search-map').removeClass('fixed');
    $('.pharmacy-search-map').parent().addClass('d-none');

    if ($('.pharmacy-search-results-pages').hasClass('swiper-wrapper')) {
      self.slider.destroy()
      $('.pharmacy-search-results').removeClass('swiper-container');
      $('.pharmacy-search-results').find('.mobile-open-filter').remove();
      $('.pharmacy-search-results').find('.mobile-geocode-location').remove();
      $('.pharmacy-search-results').find('.pharmacy-search-results-pages').removeClass('swiper-wrapper');
      $('.pharmacy-search-results').find('.pharmacy-search-results-pages').find('.pharmacy-search-result').removeClass('swiper-slide');
      // $('.pharmacy-search-results-pages').slick('unslick');
    }

    // enableBodyScroll('.pharmacy-search-map');
  },

  fixedButtonMobile() {
    $('footer').on('inview', function (event, isInView) {
      if (isInView) {
        $('#mobile-open-map').stop().fadeOut();
      } else {
        $('#mobile-open-map').fadeIn();
      }
    }).trigger('inview');
  },

  showHideFilter() {
    $('.filter-show-more').click(function () {
      $('.pharmacy-search-filter').toggleClass('show-all-filter');
    });
  },

  init() {
    let self = this;

    self.isMobile = false;
    if ($(window).width() < 992) {
      self.isMobile = true;
    }

    self.initForm();
    self.initFilter();
    self.initSuggestions();
    self.initMap();
    self.initAreaSearch();
    self.renderOpeningHours($('.pharmacy-search-results-pages').find('.pharmacy-search-result'));
    self.renderDistanceLink($('.pharmacy-search-results-pages').find('.pharmacy-search-result'));
    self.loadMore();
    self.fixedButtonMobile();
    self.showHideFilter();

    $('#mobile-open-map').on('click', function (e) {
      // disableBodyScroll();
      e.preventDefault();

      $('.pharmacy-search-results').addClass('fixed');
      $('.pharmacy-search-map').addClass('fixed');
      $('.pharmacy-search-map').parent().removeClass('d-none')

      if (thirdparty()) {
        self.gmapsResize();

        $('.pharmacy-search-results').addClass('swiper-container');
        $('.mobile-open-filter').clone(true).removeClass('d-none').prependTo('.pharmacy-search-results');
        $('.mobile-geocode-location').clone(true).removeClass('d-none').prependTo('.pharmacy-search-results');
        $('.pharmacy-search-results').find('.pharmacy-search-results-pages').addClass('swiper-wrapper');
        $('.pharmacy-search-results').find('.pharmacy-search-results-pages').find('.pharmacy-search-result').addClass('swiper-slide');

        self.slider = new Swiper('.pharmacy-search-results', {
          loop: false,
          slidesPerView: 'auto',
          spaceBetween: 15,
          centeredSlides: true,
          on: {
            init: function (swiper) {
              let $current = $(swiper.slides[swiper.realIndex]);

              $('.pharmacy-search-result').removeClass('active')
              $current.addClass('active');

              let pharmacyID = $current.data('id');

              $.each(self.markers, function () {
                if (typeof this.pharmacyID != 'undefined') {
                  if (this.pharmacyID != pharmacyID) {
                    this.setIcon(self.icon);
                  } else {
                    this.setIcon(self.iconSelected);
                  }
                }
              });
            },
            slideChange: function (swiper) {
              let $current = $(swiper.slides[swiper.realIndex]);

              $('.pharmacy-search-result').removeClass('active')
              $current.addClass('active');

              let pharmacyID = $current.data('id');

              $.each(self.markers, function () {
                if (typeof this.pharmacyID != 'undefined') {
                  if (this.pharmacyID != pharmacyID) {
                    this.setIcon(self.icon);
                  } else {
                    this.setIcon(self.iconSelected);
                  }
                }
              });

              self.gmapsResize();
            },
          },
        });
      } else {
        $('.pharmacy-search-results-pages, .mobile-open-filter, .mobile-geocode-location').hide();
      }
    });

    $('#mobile-close-map').on('click', function () {
      self.closeMap();
    });

    $('.mobile-open-filter').on('click', function (e) {
      e.preventDefault();
      let settings = self.getSettings();
      // disableBodyScroll();

      $.each(settings.filter, function (key, value) {
        if (String(value) == 'true') {
          $('#mobile-overlay-filter').find('.filter[data-filter="' + key + '"]').addClass('active');
        } else {
          $('#mobile-overlay-filter').find('.filter[data-filter="' + key + '"]').removeClass('active');
        }
      });

      $('#mobile-overlay-filter').fadeIn(500);
    });

    $('#mobile-overlay-filter').find('.close').on('click', function (e) {
      e.preventDefault('#mobile-overlay-filter');
      // enableBodyScroll();
      $('#mobile-overlay-filter').fadeOut(500);
    });

    $('#mobile-overlay-filter').find('.filter').on('click', function () {
      $(this).toggleClass('active');
    });

    $('#mobile-overlay-filter').find('.delete-filter').on('click', function (e) {
      e.preventDefault();
      $('#mobile-overlay-filter').find('.active').each(function () {
        $(this).click();
      });
      $('#mobile-overlay-filter').find('.filter').removeClass('active');
      $('#mobile-overlay-filter').find('.save-filter').trigger('click');
    });

    $('#mobile-overlay-filter').find('.save-filter').on('click', function (e) {
      e.preventDefault();

      self.clearResults();
      self.showLoader();

      $('#mobile-overlay-filter').fadeOut(500);

      let settings = self.getSettings();

      $.each($('#mobile-overlay-filter').find('.filter'), function () {
        var filterKey = $(this).data('filter');

        if ($(this).hasClass('active')) {
          settings.filter[filterKey] = true;
          $('.pharmacy-search-filter').find('.filter[data-filter="' + filterKey + '"]').addClass('active');
        } else {
          settings.filter[filterKey] = false;
          $('.pharmacy-search-filter').find('.filter[data-filter="' + filterKey + '"]').removeClass('active');
        }
      });

      if (self.setSettings(settings)) {
        self.setUrl();
        self.loadResults(1);
      }
    });

    if ($('.close-last-seen').length > 0) {
      $('.close-last-seen').click(function () {
        $('.pharmacy-search-results').find('.pharmacy-search-last-seen-title').fadeOut(500, function () {
          $(this).remove();
        });

        $(this).parent('.pharmacy-search-last-seen').fadeOut(500, function () {
          $(this).remove();
        });

        $('.pharmacy-search-results').find('.pharmacy-search-shop-link').fadeOut(500, function () {
          $(this).remove();
        })

        let $promotionalProductFilter = $('.pharmacy-search-filter').find('button[data-filter="promotional-product"]');
        if($promotionalProductFilter.hasClass('active')){
          $promotionalProductFilter.click();
        }

        remove_last_seen_product_cookie();
        remove_last_seen_promotion_cookie();
      });
    }
  },

  finalize() {
    let self = this;

    // Open Map after Cookie Banner save
    $(document).ready(function () {
      self.gmapsResize();

      let openMap = window.sessionStorage.getItem('open-map');
      if (openMap != undefined && $(window).width() < 992) {
        let to2 = setTimeout(function () {
          clearTimeout(to2);
          window.sessionStorage.removeItem('open-map');
          $('#mobile-open-map').click();
        }, 0);
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/pharmacy-search.js